import { styled } from '@mui/material/styles';
import { NotificationProps, Notification as RaNotification } from 'react-admin';

const StyledNotification = styled(
  RaNotification,
  {}
)(({ theme }) => ({
  zIndex: 2000,
  '& *': {
    fontSize: theme.typography.body1.fontSize
  }
}));
function Notification(props: NotificationProps) {
  return <StyledNotification {...props} />;
}
export { Notification };
